import PoppinsRegular from "../fonts/Poppins/Poppins-Regular.ttf"
import PoppinsLight from "../fonts/Poppins/Poppins-Light.otf"
import PoppinsBold from "../fonts/Poppins/Poppins-Bold.otf"

export const poppinsBold = {
  fontFamily: 'PoppinsBold',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    local('PoppinsBold'),
    local('PoppinsBold'),
    url(${PoppinsBold}) format('truetype')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const poppinsRegular = {
  fontFamily: 'PoppinsRegular',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('PoppinsRegular'),
    local('PoppinsRegular'),
    url(${PoppinsRegular}) format('truetype')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export const poppinsLight = {
  fontFamily: 'PoppinsLight',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 100,
  src: `
    local('PoppinsLight'),
    local('PoppinsLight'),
    url(${PoppinsLight}) format('truetype')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};